/* eslint-disable prettier/prettier */
import React, { useEffect } from 'react'

import { EditorHeader } from 'src/components/NewsModule/Header'
import ManagementContent from 'src/components/NewsModule/Management'
import ModuleFooter from 'src/components/NewsModule/Footer'
import usePersistedState from 'src/hooks/usePersistedState'
import { MY_NEWS_SCREEN } from 'src/components/NewsModule/constants'
import { useHistory } from 'react-router-dom'
import checkPermission from 'src/utils/checkPermission'

const MyNews = () => {
  const history = useHistory()
  const [user, setUser] = usePersistedState('auth-token', '')
  const [prevPage, setPrevPage] = usePersistedState('prev-page', '')

  useEffect(() => {
    if (user) {
      if (!checkPermission(user, MY_NEWS_SCREEN)) {
        history.push('/notFound')
      } else {
        setPrevPage('/news/management/my-news')
      }
    }
  }, [user])

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }, [])

  return (
    <>
      <React.Suspense fallback="loading..">
        <EditorHeader current="MANAGEMENT" />
        <ManagementContent context={'MyNews'} />
        <ModuleFooter />
      </React.Suspense>
    </>
  )
}

export default MyNews
